'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import shallowCompare from 'react-addons-shallow-compare';
import menuDropTarget from 'simple-menus-lib/components/dnd/decorators/menuDropTarget';
import withVisibilityChecker from 'simple-menus-lib/components/menu/decorators/withVisibilityChecker';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import UIScrollContainer from 'UIComponents/scroll/UIScrollContainer';
import UIDragHandle from 'UIComponents/draggable/UIDragHandle';
import MenuItemLabel from 'simple-menus-lib/components/menu/MenuItemLabel';
import MenuItemOptions from 'simple-menus-lib/components/menu/MenuItemOptions';
import { compose } from 'redux';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class MenuItem extends Component {
  shouldComponentUpdate(nextProps, nextState) {
    if (!nextProps.isVisible) return false;
    return shallowCompare(this, nextProps, nextState);
  }
  get classNames() {
    const {
      isOver,
      canDrop
    } = this.props;
    return classNames('simple-menus-menu-item', isOver && 'is--over' + (!canDrop ? " no--drop" : ""));
  }
  get contentStyles() {
    return {
      display: !this.props.isVisible && 'none'
    };
  }
  render() {
    const {
      connectDropTarget,
      hasChildren,
      id,
      isCollapsed,
      isVisible,
      menuId,
      parentId,
      readOnly,
      toggleCollapse
    } = this.props;
    return connectDropTarget( /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx("div", {
        className: this.classNames,
        children: /*#__PURE__*/_jsx(UICardWrapper, {
          compact: true,
          className: "simple-menus-item-card-wrapper",
          children: /*#__PURE__*/_jsx(UIScrollContainer, {
            children: /*#__PURE__*/_jsx(UIDragHandle, {
              position: "start",
              children: /*#__PURE__*/_jsxs("div", {
                className: "simple-menus-menu-item-content",
                "data-test-id": "menu-item",
                children: [/*#__PURE__*/_jsx("div", {
                  className: "menu-content-left",
                  style: this.contentStyles,
                  children: /*#__PURE__*/_jsx(MenuItemLabel, {
                    id: id,
                    hasChildren: hasChildren,
                    toggleCollapse: toggleCollapse,
                    isCollapsed: isCollapsed,
                    readOnly: readOnly
                  })
                }), /*#__PURE__*/_jsx("div", {
                  className: "menu-content-right",
                  style: this.contentStyles,
                  children: /*#__PURE__*/_jsx(MenuItemOptions, {
                    id: id,
                    isVisible: isVisible,
                    parentId: parentId,
                    menuId: menuId,
                    readOnly: readOnly
                  })
                })]
              })
            })
          })
        })
      })
    }));
  }
}
MenuItem.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  parentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  menuId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  connectDropTarget: PropTypes.func.isRequired,
  isOver: PropTypes.bool,
  canDrop: PropTypes.bool,
  hasChildren: PropTypes.bool.isRequired,
  toggleCollapse: PropTypes.func.isRequired,
  isCollapsed: PropTypes.bool.isRequired,
  isVisible: PropTypes.bool.isRequired,
  readOnly: PropTypes.bool
};
export default compose(menuDropTarget(), withVisibilityChecker())(MenuItem);